import { createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../../app/api/authApi";
import { logout } from "./authSlice";

/**
 * Centralised logout: revokes the refresh-token cookie on the server and flips the
 * `loggedOut` flag so `useAuth` reports the session as gone immediately.
 *
 * We deliberately do NOT call `baseApi.util.resetApiState()` here. Doing so while
 * protected components are still mounted (they only unmount once `PrivateOutlet`'s
 * <Navigate> commits) would invalidate every cache entry, causing every subscribed
 * RTK Query hook to refetch and 401, polluting the console and burning rate-limit
 * budget. Stale per-user data is wiped instead at the start of the next successful
 * login (see `authApi.takeToken.onQueryStarted`).
 *
 * Lives in a separate file from `authSlice` so the slice itself stays free of
 * `baseApi`/`authApi` imports, allowing `baseApi` to import `logout` for its own
 * auto sign-out (refresh failure) without creating an import cycle.
 */
export const logoutThunk = createAsyncThunk("authSlice/logoutThunk", async (_, { dispatch }) => {
    try {
        await dispatch(authApi.endpoints.logoutUser.initiate()).unwrap();
    } finally {
        dispatch(logout());
    }
});
